import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "ml-4" }
const _hoisted_2 = { class: "subtitleDashboard" }
const _hoisted_3 = {
  class: "subtitleDashboard",
  style: {"font-size":"24px !important"}
}
const _hoisted_4 = { class: "subtitleGAUGE" }

import { ref, Ref, onMounted, computed, ComputedRef, watch } from 'vue';
import { format } from "@formkit/tempo";

/********************************
 ************ I18N **************
 *******************************/
import { useI18n } from 'vue-i18n';
import { STRING_GENERAL } from '@/constants/labels';

/********************************
 ************ STORE *************
 *******************************/
import { useStore } from 'vuex';
import { useDisplay } from 'vuetify';
import HexagonMinComponent from '@/components/principalPage/hexagonMinComponent.vue';
import Prog_circular from '@/components/PrincipalComponents/Prog_circular.vue';

/********************************
 ********** INTERFACES **********
 *******************************/
import { ItemStatus, ItemStatusArray } from '@/interfaces/SmartLink/Equips';

/********************************
 *********** FUNCTION ***********
 *******************************/
import { getFinDate, getTimeZone } from '@/functions/project';
import { OPERABILITY } from '@/interfaces/SmartLink/Equipos';


export default /*@__PURE__*/_defineComponent({
  __name: 'GaugeComponent',
  props: {
    recharge    : { type: Boolean, required: true },
    arrayItems  : { type: Array<OPERABILITY>, required: true },
    valorCard   : { type: String, default: 'distri'}
},
  setup(__props) {

const { t } = useI18n();

/********************************
 ********** CONSTANTES **********
 *******************************/
const store = useStore();

/********************************
 ************ VUETIFY ***********
 *******************************/
const { smAndDown } = useDisplay();

/********************************
 ********** COMPONENTS **********
 *******************************/
const props = __props


/***************************************
************ MENU DESPEGABLE *********** 
***************************************/

const menu      = ref(false);
const minValue  = ref(60);
const maxValue  = ref(90);
const sizeHexa  = ref(120);
const sizeTitl  = ref(30);
const sizeSubt  = ref(13);

const fieldRules = computed ( () =>  [(v:number) => !!v || 'Requerido',],)

watch (minValue, (valor:number) => {
    const limitValue =  ref( maxValue.value - 1 );
    if(valor >= limitValue.value && valor > 0) minValue.value = limitValue.value ;
    if(valor < 0 ) { minValue.value = 1 }
} )

watch (maxValue, (valor:number) => {
    const limitValue = ref( minValue.value + 1 );
    if(valor <= limitValue.value && valor < 100 && valor > 0) minValue.value = limitValue.value ;
    if(valor > 100 ) maxValue.value = 99;
} )

const upValue = (typeValue:string) => {
    if(typeValue === 'minValue') minValue.value ++;
    if(typeValue === 'maxValue') maxValue.value ++;
}
const downValue = (typeValue:string) => {
    if(typeValue === 'minValue') minValue.value --;
    if(typeValue === 'maxValue') maxValue.value --;
}


/***************************************
************** CAPTURA IEO ************* 
***************************************/
const timezone          = getTimeZone();
const isRecharge        = computed(()=> props.recharge)
const valorCard         = computed(()=> props.valorCard)
const showError         = ref(false);
const showGraph         = ref(false);
const totalItemsOper:ComputedRef<OPERABILITY[]> = computed(() => props.arrayItems);
const itemsFiltered:Ref<OPERABILITY[]>   = ref([]);

/**
 * IEO del día
 */
const finalItemsDay:Ref<ItemStatus>      = ref({ item : {ok: 0,alert: 0,alarm: 0,down: 0 }});

/**
 * IEO de los últimos 15 minutos (último registro)
 */
const finalItemsNow:Ref<ItemStatus>      = ref({ item : {ok: 0,alert: 0,alarm: 0,down: 0 }});

/**
 * IEO de la semana
 */
const finalItemsSeman:Ref<ItemStatus>    = ref({ item : {ok: 0,alert: 0,alarm: 0,down: 0 }});

/**
 * IEO del mes
 */
const finalItems2Seman:Ref<ItemStatus>    = ref({ item : {ok: 0,alert: 0,alarm: 0,down: 0 }});


/**
 * Obtienes el tiempo en el formato correspondiente y tambien dependiendo de la zona horaria
 * @param time 
 * @param timezone 
 */
 const getTime = (time:Date, timezone:string) => {
    const finalTime =  format({
        date: time,
        format: "YYYY-MM-DD HH:mm:ss",
        tz: timezone,
    })
    return finalTime.toString()
}


/**
 * Captura las fehas iniciales y finales, dependiendo de la zona horaria
 * para poder ver datos correctos desde cualquier parte del mundo
 * desde el navegador
 * @param minutes 
 * @param petition (SOLO para discriminar al final y almacenar en la variable correspondiente)
 */
const getIEOByDates = (minutes:number, petition: number) => {
    showError.value     = false;
    showGraph.value     = false;
    const nowTime       = getFinDate();
    const dateFin       = getFinDate();

    
    const minusMinute   = nowTime.getTime() - (1000 * 60 * minutes);
    const iniDate       = new Date(minusMinute);
    
    getObjectByDates(getTime(iniDate, timezone),getTime(dateFin, timezone),petition);
}


/**
 * Teniendo los valores de la fecha iniciante (minutos atrás) y la fecha final (fecha actual),
 * capturamos los valores que se encuentran dentro de ese rango de fechas
 * 
 * @param dateIni 
 * @param dateFin 
 * @param petition (SOLO para discriminar al final y almacenar en la variable correspondiente)
 */
const getObjectByDates = (dateIni:string, dateFin:string, petition:number) => {
    itemsFiltered.value = [];

    // Si petition es igual a 4 (ultimos 15 minutos), se obtendra el ultimo valor registrado
    // Esto con el fin de evitar valores 0 dentro del 'IEO en línea'
    // if(petition == 4 && ipAPIS !== 'http://192.168.2.223:4159/api/') { //CAMBIAR LAS IPAPIS
    if(petition == 4) {
        itemsFiltered.value.push(totalItemsOper.value[0])
    } 
    // Para todos los demás casos, se capturan los datos dentro del rango de fechas establecidas
    else{
        totalItemsOper.value.forEach((item:OPERABILITY) => {
            if(item.fecha && new Date(item.fecha).getTime() <= new Date(dateFin).getTime() && new Date(item.fecha).getTime() >= new Date(dateIni).getTime()){
                itemsFiltered.value.push(item)
            }
        })
    }
    getFinalItemsToShow(itemsFiltered.value, petition)
}

/**
 * Captura el promedio de los valores de ok, alertas, alarmas y caidos, dependiendo de los tiempos establecidos
 * anteriormente y los almacena en las variables, dependiendo del tipo de petición
 * @param allData (datos filtrados por fecha)
 * @param typePetition (para almacenar en variables distintas)
 */
const getFinalItemsToShow = (allData:Array<OPERABILITY>,typePetition:number) => {
    
    //Creo los array de números
    let OBJOperability:ItemStatusArray = {
        item: {
            ok      : [],
            alert   : [],
            alarm   : [],
            down    : [],
        },
    }

    // Si hay información obtenida, se realizará la lógica
    if(allData.length >= 1){
        showError.value = false;
        allData.forEach((elem:OPERABILITY)=>{
            let cantTotal      = (elem.ok??0) + ( elem.alarm??0) + (elem.alert??0) + (elem.down??0);
            let ok             = (elem.ok??0)/cantTotal;
            let alerta         = (elem.alarm??0)/cantTotal;
            let alarma         = (elem.alert??0)/cantTotal;
            let down           = (elem.down??0)/cantTotal;

            // para evitar los NaN en el IEO, porque son equipos que no registran ningun estado en el tiempo.
            if(cantTotal === 0) {
                ok      = 0;
                alerta  = 0;
                alarma  = 0;
                down    = 0;
            }

            // hago el push del IEO de cada item en cada objeto correspondiente, 
            // para el caso del OK, coloco un default de 0, por si presentan valores NaN (por comprobar)
            OBJOperability.item.ok.push(ok??0)
            OBJOperability.item.alarm.push(alerta)
            OBJOperability.item.alert.push(alarma)
            OBJOperability.item.down.push(down)  
        })


        // Sumamos los elementos de cada Array
        // Sacamos la cantidad de elementos que tiene el array
        // Promediamos
        let sumOkitem = OBJOperability.item.ok.reduce((a:number, b:number) => a + b);
        let totOkitem = OBJOperability.item.ok.length;
        let proOkitem = sumOkitem/totOkitem;

        let sumAlertitem = OBJOperability.item.alert.reduce((a:number, b:number) => a + b);
        let totAlertitem = OBJOperability.item.alert.length;
        let proAlertitem = sumAlertitem/totAlertitem;

        let sumAlarmitem = OBJOperability.item.alarm.reduce((a:number, b:number) => a + b);
        let totAlarmitem = OBJOperability.item.alarm.length;
        let proAlarmitem = sumAlarmitem/totAlarmitem;

        let sumDownitem = OBJOperability.item.down.reduce((a:number, b:number) => a + b);
        let totDownitem = OBJOperability.item.down.length;
        let proDownitem = sumDownitem/totDownitem;

        // reemplazamos los valores del array final por los valores obtenidos (promedio obtenido)
        let finalArray = {
            item : {
                ok      : parseFloat(proOkitem.toFixed(2)),
                alert   : proAlertitem,
                alarm   : proAlarmitem,
                down    : proDownitem,
            },
        }

        //Dependiendo del tipo de pedido, lo guardo en su variable correspondiente
        typePetition === 0 ? finalItemsDay.value    = finalArray : null; //array del dia
        typePetition === 2 ? finalItemsSeman.value  = finalArray : null; //array de la semana
        typePetition === 3 ? finalItems2Seman.value  = finalArray : null; //array del mes
        typePetition === 4 ? finalItemsNow.value    = finalArray : null; //array en linea
    }
    showGraph.value = true;
}

watch(isRecharge, (rech:boolean) =>{
    if(rech) {
        if(props.arrayItems.length > 0){
            getIEOByDates(1440,0);  //1440 minutos (1 dia)
            getIEOByDates(10080,2); //10080 minutos (1 semana)
            getIEOByDates(20160,3); //20160 minutos (2 semanas)
            getIEOByDates(15,4);    //15 minutos (ultimo registro)    
        }
    }
})


/**
 * Al final de cada ciclo y dependiendo del valor que viene del props
 * Almacena el valor del IEO de los ultimos 15 minutos de cada Familia
 * en la STORE y este se usara para mostrarlo al lado del Mapa
 * encima de los mensajes de alarma y alertas
 */
watch(showGraph,(isShow:boolean) => {
    if(isShow){
        if(valorCard.value === STRING_GENERAL.distri) store.commit('setIEODistri',finalItemsNow.value.item.ok.toFixed(2)??'0')
        if(valorCard.value === STRING_GENERAL.access) store.commit('setIEOAcceso',finalItemsNow.value.item.ok.toFixed(2)??'0')
        if(valorCard.value === STRING_GENERAL.client) store.commit('setIEOClient',finalItemsNow.value.item.ok.toFixed(2)??'0')
    }
})

onMounted(async ()=>{
    //Si trae algún array con minimo un valor, hará toda la lógica que encuentra
    if(props.arrayItems.length > 0){
        getIEOByDates(1440,0); //1440 minutos (1 dia)
        getIEOByDates(10080,2); //10080 minutos (1 semana)
        getIEOByDates(20160,3); //20160 minutos (2 semanas)
        getIEOByDates(15,4); //15 minutos (ultimo registro) 
    }
    //Si no encuentra, mostrará los valores 0
    //Entra al Watch
    else{
        showGraph.value = true;
    }
})


return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    color: "bgtopology",
    elevation: "0"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "pa-0" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, {
            justify: "space-between",
            class: "ma-0"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("span", _hoisted_2, [
                  _createTextVNode(_toDisplayString(_unref(t)('labels.ociTitle')) + " ", 1),
                  _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)('labels.oci')), 1)
                ])
              ]),
              _createVNode(_component_v_menu, {
                modelValue: menu.value,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((menu).value = $event)),
                class: "menuGauge",
                "close-on-content-click": false,
                location: "end"
              }, {
                activator: _withCtx(({ props }) => [
                  _createVNode(_component_v_btn, _mergeProps({
                    color: "colorText",
                    variant: "text",
                    icon: "mdi-cog-outline",
                    size: "small"
                  }, props), null, 16)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_sheet, {
                    width: "800",
                    height: "110",
                    color: "bgtopology"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, {
                        class: "ma-3",
                        justify: "space-between"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)('labels.confIEO')), 1),
                          _createVNode(_component_v_btn, {
                            icon: "mdi-close",
                            density: "compact",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (menu.value = false)),
                            variant: "text"
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_row, {
                        class: "ma-0",
                        justify: "space-between"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_sheet, {
                            class: "centerCard",
                            color: "transparent",
                            width: "60"
                          }, {
                            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                              _createTextVNode(" 0 % ", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_component_v_sheet, {
                            class: "centerCard gaugeCardFilter cardBorderColorRed",
                            color: "transparent",
                            width: "140"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('labels.alarm')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_sheet, {
                            color: "transparent",
                            width: "90"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                modelValue: minValue.value,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((minValue).value = $event)),
                                suffix: "%",
                                width: "90",
                                variant: "outlined",
                                density: "compact",
                                type: "number",
                                "hide-details": "",
                                "hide-spin-buttons": "",
                                rules: fieldRules.value
                              }, {
                                append: _withCtx(() => [
                                  _createVNode(_component_v_col, { class: "pa-0" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_sheet, {
                                        height: "20",
                                        color: "transparent"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_icon, {
                                            size: "small",
                                            disabled: minValue.value >= maxValue.value - 1,
                                            onClick: _cache[1] || (_cache[1] = ($event: any) => (upValue('minValue')))
                                          }, {
                                            default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                                              _createTextVNode(" mdi-menu-up ", -1)
                                            ]))]),
                                            _: 1
                                          }, 8, ["disabled"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_sheet, {
                                        color: "transparent",
                                        height: "20"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_icon, {
                                            size: "small",
                                            disabled: minValue.value <= 0 ,
                                            onClick: _cache[2] || (_cache[2] = ($event: any) => (downValue('minValue')))
                                          }, {
                                            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                              _createTextVNode(" mdi-menu-down ", -1)
                                            ]))]),
                                            _: 1
                                          }, 8, ["disabled"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue", "rules"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_sheet, {
                            class: "centerCard gaugeCardFilter cardBorderColorYellow",
                            color: "transparent",
                            width: "140"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('labels.alert')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_sheet, {
                            color: "transparent",
                            width: "90"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                modelValue: maxValue.value,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((maxValue).value = $event)),
                                suffix: "%",
                                width: "90",
                                variant: "outlined",
                                density: "compact",
                                type: "number",
                                "hide-details": "",
                                "hide-spin-buttons": "",
                                rules: fieldRules.value
                              }, {
                                append: _withCtx(() => [
                                  _createVNode(_component_v_col, { class: "pa-0" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_sheet, {
                                        height: "20",
                                        color: "transparent"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_icon, {
                                            size: "small",
                                            disabled: maxValue.value >= 99,
                                            onClick: _cache[4] || (_cache[4] = ($event: any) => (upValue('maxValue')))
                                          }, {
                                            default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                              _createTextVNode(" mdi-menu-up ", -1)
                                            ]))]),
                                            _: 1
                                          }, 8, ["disabled"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_sheet, {
                                        color: "transparent",
                                        height: "20"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_icon, {
                                            size: "small",
                                            disabled: maxValue.value - 1 <= minValue.value && minValue.value >= 0 ,
                                            onClick: _cache[5] || (_cache[5] = ($event: any) => (downValue('maxValue')))
                                          }, {
                                            default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                              _createTextVNode(" mdi-menu-down ", -1)
                                            ]))]),
                                            _: 1
                                          }, 8, ["disabled"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue", "rules"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_sheet, {
                            class: "centerCard gaugeCardFilter cardBorderColorGreen",
                            color: "transparent",
                            width: "140"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('labels.ok')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_sheet, {
                            class: "centerCard",
                            color: "transparent",
                            width: "60"
                          }, {
                            default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                              _createTextVNode(" 100 % ", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_text, {
        class: "pa-0",
        style: {"text-align":"-webkit-center"}
      }, {
        default: _withCtx(() => [
          (showGraph.value)
            ? (_openBlock(), _createBlock(_component_v_sheet, {
                key: 0,
                class: "gaugeClass",
                color: "transparent",
                width: _unref(smAndDown) ? '395' :'100%',
                height: "400"
              }, {
                default: _withCtx(() => [
                  _createVNode(HexagonMinComponent, {
                    class: "HexagonPos Hex1",
                    title: finalItemsNow.value.item.ok.toFixed(2),
                    color: 'red',
                    subtitle: _unref(t)('labels.online'),
                    minValue: minValue.value/100,
                    maxValue: maxValue.value/100,
                    "size-hexa": 160,
                    "size-title": 55,
                    "size-sub-ti": 16
                  }, null, 8, ["title", "subtitle", "minValue", "maxValue"]),
                  _createVNode(HexagonMinComponent, {
                    class: "HexagonPos Hex2",
                    title: finalItemsDay.value.item.ok.toFixed(2),
                    color: '',
                    subtitle: _unref(t)('labels.day'),
                    minValue: minValue.value/100,
                    maxValue: maxValue.value/100,
                    "size-hexa": sizeHexa.value,
                    "size-title": sizeTitl.value,
                    "size-sub-ti": sizeSubt.value
                  }, null, 8, ["title", "subtitle", "minValue", "maxValue", "size-hexa", "size-title", "size-sub-ti"]),
                  _createVNode(HexagonMinComponent, {
                    class: "HexagonPos Hex3",
                    title: finalItems2Seman.value.item.ok.toFixed(2),
                    color: '',
                    subtitle: '2 ' + _unref(t)('labels.week') + 's',
                    minValue: minValue.value/100,
                    maxValue: maxValue.value/100,
                    "size-hexa": sizeHexa.value,
                    "size-title": sizeTitl.value,
                    "size-sub-ti": sizeSubt.value
                  }, null, 8, ["title", "subtitle", "minValue", "maxValue", "size-hexa", "size-title", "size-sub-ti"]),
                  _createVNode(HexagonMinComponent, {
                    class: "HexagonPos Hex4",
                    title: finalItemsSeman.value.item.ok.toFixed(2),
                    color: '',
                    subtitle: _unref(t)('labels.week'),
                    minValue: minValue.value/100,
                    maxValue: maxValue.value/100,
                    "size-hexa": sizeHexa.value,
                    "size-title": sizeTitl.value,
                    "size-sub-ti": sizeSubt.value
                  }, null, 8, ["title", "subtitle", "minValue", "maxValue", "size-hexa", "size-title", "size-sub-ti"])
                ]),
                _: 1
              }, 8, ["width"]))
            : _createCommentVNode("", true),
          (!showGraph.value && !showError.value)
            ? (_openBlock(), _createBlock(_component_v_row, {
                key: 1,
                class: "pt-5",
                justify: "center"
              }, {
                default: _withCtx(() => [
                  _createVNode(Prog_circular)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})